"use strict";

module.exports = function () {
    return {
        restrict: "AE",
        replace: true,
        template: "<div class=\"infinite-scroll-loading-indicator\"><div></div>Loading</div>"
    };
}
